import { makeStyles } from '@material-ui/core/styles';
import theme from '../../../theme';

const useStyles = makeStyles(() => ({
  wrapper: {
    margin: 20,
    [theme.breakpoints.down('sm')]: {
      margin: '0 5px',
    },
    [theme.breakpoints.down('xs')]: {
      margin: 0,
    },
  },
  lead__flex: {
    display: 'flex',
    [theme.breakpoints.down('sm')]: {
      flexDirection: 'column',
    },
  },
  card: {
    padding: 15,
    background: 'white',
    borderRadius: '12px',
    border: '1px solid #e9ecef',
    maxWidth: `calc(100vw - ${350}px)`,
    [theme.breakpoints.down('md')]: {
      maxWidth: `calc(100vw - ${250}px)`,
    },
    [theme.breakpoints.down('sm')]: {
      padding: 5,
      margin: 10,
      marginBottom: 15,
      maxWidth: '100%',
    },
    [theme.breakpoints.down('xs')]: {
      padding: 8,
      margin: 5,
      borderRadius: '8px',
    },
  },
  table: {
    minWidth: 1000,
    tableLayout: 'auto',
    width: '100%',
    [theme.breakpoints.down('lg')]: {
      minWidth: 800,
    },
    [theme.breakpoints.down('md')]: {
      minWidth: 600,
    },
    [theme.breakpoints.down('sm')]: {
      minWidth: 300,
    },
    [theme.breakpoints.down('xs')]: {
      minWidth: 'auto',
    },
    '& thead': {
      position: 'sticky',
      top: 0,
      zIndex: 100,
      backgroundColor: '#D3DFE8',
    },
    '& thead tr:first-child th': {
      position: 'sticky',
      top: 0,
      backgroundColor: '#D3DFE8',
      zIndex: 100,
      borderBottom: 'none',
      borderLeft: '1px solid white',
      borderRight: '1px solid white',
      borderTop: 'none',
      padding: '2px 4px',
      height: '40px',
      textAlign: 'center',
      fontWeight: 600,
      fontSize: '14px',
      color: '#333',
      boxSizing: 'border-box',
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      whiteSpace: 'nowrap',
      [theme.breakpoints.down('sm')]: {
        fontSize: '12px',
        padding: '2px 2px',
        height: '36px',
      },
      [theme.breakpoints.down('xs')]: {
        fontSize: '10px',
        padding: '1px 2px',
        height: '32px',
      },
      '&:first-child': {
        borderLeft: 'none',
      },
      '&:last-child': {
        borderRight: 'none',
      },
    },
    '& thead tr:nth-child(2) th': {
      position: 'sticky',
      top: '40px', // Position below the first row
      backgroundColor: '#D3DFE8',
      zIndex: 100,
      borderBottom: '1px solid #e0e0e0',
      borderLeft: '1px solid white',
      borderRight: '1px solid white',
      borderTop: 'none',
      padding: '2px 4px',
      height: '32px',
      textAlign: 'center',
      boxSizing: 'border-box',
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      whiteSpace: 'nowrap',
      [theme.breakpoints.down('sm')]: {
        top: '36px',
        height: '28px',
        padding: '2px 2px',
        fontSize: '11px',
      },
      [theme.breakpoints.down('xs')]: {
        top: '32px',
        height: '24px',
        padding: '1px 2px',
        fontSize: '10px',
      },
      '&:first-child': {
        borderLeft: 'none',
      },
      '&:last-child': {
        borderRight: 'none',
      },
    },
    '& tbody tr td': {
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      whiteSpace: 'nowrap',
      padding: '12px 8px',
      [theme.breakpoints.down('sm')]: {
        padding: '10px 6px',
        fontSize: '12px',
      },
    },
    
  },
  tableWrapper: {
    display: 'flex',
    flexDirection: 'column',
    height: 'calc(100vh - 200px)',
    minHeight: '500px',
    maxHeight: '900px',
    flex: 1,
    overflowY: 'auto',
    overflowX: 'auto',
    [theme.breakpoints.down('md')]: {
      height: 'calc(100vh - 240px)',
      maxHeight: '700px',
    },
    [theme.breakpoints.down('sm')]: {
      height: 'calc(100vh - 280px)',
      maxHeight: '600px',
      minHeight: '400px',
    },
    [theme.breakpoints.down('xs')]: {
      height: 'calc(100vh - 320px)',
      maxHeight: '500px',
      minHeight: '300px',
    },
  },
  tableContainer: {
    flex: 1,
    overflowY: 'auto',
    overflowX: 'auto',
    marginBottom: '16px',
    maxHeight: '100%',
  },
  link: {
    color: '#0066cc',
    textDecoration: 'none',
    '&:hover': {
      textDecoration: 'underline',
    },
  },
  turnaround: {
    color: '#ff6b00',
    alignItems: 'center',
    width: '180px',
    fontSize: '14px',
  },
  turnaroundChip: {
    padding: '4px 8px',
    height: '16px',
    borderRadius: '8px',
    display: 'inline-block',
    whiteSpace: 'nowrap',
    width: '80px',
    textAlign: 'center',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    fontSize: '12px',
    cursor: 'pointer',
    position: 'relative',
  },
  turnaroundChipShort: {
    background: '#fb842e42',
    color: '#ff6b00',
    whiteSpace: 'nowrap',
  },
  turnaroundChipLong: {
    background: '#9c27b02e',
    color: '#9c27b0',
    whiteSpace: 'nowrap',
  },
  probability: {
    padding: '4px 8px',
    borderRadius: '4px',
    fontWeight: 500,
  },
  high: {
    backgroundColor: '#ffebee',
    color: '#ff1744',
  },
  orange: {
    backgroundColor: '#fff3e0',
    color: '#ff6b00',
  },
  recommendation: {
    backgroundColor: '#e8f5e9',
    color: '#00c853',
    padding: '4px 8px',
    borderRadius: '4px',
    fontWeight: 500,
  },
  acquired: {
    backgroundColor: '#217a3c',
    color: 'white',
    borderRadius: '6px',
    padding: '4px 0',
    fontWeight: 700,
    fontSize: '16px',
    width: '140px',
    display: 'inline-block',
    textAlign: 'center',
    [theme.breakpoints.down('sm')]: {
      width: '100px',
      fontSize: '14px',
      padding: '3px 0',
    },
    [theme.breakpoints.down('xs')]: {
      width: '80px',
      fontSize: '12px',
      padding: '2px 0',
    },
  },
  ordered: {
    backgroundColor: '#e3ecf5',
    color: '#1a3552',
    borderRadius: '6px',
    padding: '4px 0',
    fontWeight: 700,
    fontSize: '16px',
    width: '140px',
    display: 'inline-block',
    textAlign: 'center',
    [theme.breakpoints.down('sm')]: {
      width: '100px',
      fontSize: '14px',
      padding: '3px 0',
    },
    [theme.breakpoints.down('xs')]: {
      width: '80px',
      fontSize: '12px',
      padding: '2px 0',
    },
  },
  colorPrimary: {
    backgroundColor: '#E5E5E5',
  },
  barColorPrimary: {
    backgroundColor: '#109CF1',
  },
  cartSummary: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'flex-start',
    backgroundColor: '#f8f9fa',
    border: '1px solid #ddd',
    borderRadius: '8px',
    padding: '16px',
    marginTop: '8px',
  },
  cartLeft: {
    flex: 1,
    marginRight: '16px',
  },
  cartRight: {
    display: 'flex',
    alignItems: 'center',
    gap: '16px',
  },
  cartHeader: {
    display: 'flex',
    alignItems: 'center',
    gap: '8px',
    marginBottom: '12px',
    fontWeight: 600,
    fontSize: '16px',
    '& svg': {
      color: '#1a3552',
    },
  },
  cartItems: {
    display: 'flex',
    flexWrap: 'wrap',
    gap: '12px',
  },
  cartItem: {
    display: 'flex',
    alignItems: 'center',
    gap: '8px',
    fontSize: '14px',
    '& span:first-child': {
      fontWeight: 500,
    },
    '& span:nth-child(2)': {
      color: '#1a3552',
      fontWeight: 600,
    },
  },
  cartTotal: {
    fontSize: '18px',
    color: '#1a3552',
    textAlign: 'right',
  },
  proceedButton: {
    backgroundColor: '#1a3552',
    color: 'white',
    border: 'none',
    padding: '8px 16px',
    borderRadius: '6px',
    cursor: 'pointer',
    fontWeight: 600,
    fontSize: '14px',
    '&:hover': {
      backgroundColor: '#283593',
    },
  },
  purchaseCell: {
    display: 'flex',
    alignItems: 'center',
    gap: '4px',
    justifyContent: 'center',
  },
  qtyInput: {
    '& input': {
      textAlign: 'center',
      padding: '2px 4px',
      border: '1px solid #ccc',
      borderRadius: '3px',
      backgroundColor: 'transparent',
      fontSize: '11px',
      width: '26px',
      minWidth: '26px',
    },
  },
  qtyButton: {
    minWidth: '18px',
    width: '18px',
    height: '18px',
    padding: 0,
    backgroundColor: '#f0f0f0',
    border: 'none',
    borderRadius: '3px',
    color: '#333',
    '&:hover': {
      backgroundColor: '#e0e0e0',
    },
    '&:disabled': {
      backgroundColor: '#f5f5f5',
      color: '#ccc',
    },
  },
  orderButton: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'center',
    padding: '6px 8px',
    gap: '6px',
    width: '80px',
    height: '22px',
    background: '#127127',
    borderRadius: '4px',
    border: 'none',
    cursor: 'pointer',
    fontFamily: 'Roboto',
    fontStyle: 'normal',
    fontWeight: 700,
    fontSize: '12px',
    lineHeight: '150%',
    textAlign: 'center',
    letterSpacing: '0.02em',
    color: '#FFFFFF',
    flex: 'none',
    flexGrow: 0,
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    '&:hover': {
      backgroundColor: '#0f5f0f',
    },
    '&:disabled': {
      backgroundColor: '#cccccc',
      cursor: 'not-allowed',
    },
    [theme.breakpoints.down('sm')]: {
      width: '90px',
      height: '24px',
      padding: '6px 8px',
      gap: '4px',
      fontSize: '11px',
      minWidth: '90px',
    },
    [theme.breakpoints.down('xs')]: {
      width: '85px',
      height: '22px',
      padding: '5px 6px',
      gap: '3px',
      fontSize: '10px',
      minWidth: '85px',
    },
  },
  customToast: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'flex-start',
    alignItems: 'center',
    padding: '5px 10px',
    gap: '10px',
    width: '300px',
    height: '28px',
    background: 'linear-gradient(0deg, rgba(255, 255, 255, 0.9), rgba(255, 255, 255, 0.9)), #127127',
    borderRadius: '5px',
    marginRight: '10px',
    transition: 'opacity 0.3s ease-in-out',
    position: 'fixed',
    top: '20px',
    right: '20px',
    zIndex: 9999,
    [theme.breakpoints.down('sm')]: {
      height: 'auto',
      minHeight: '40px',
      padding: '8px 12px',
      gap: '8px',
      top: '10px',
      right: '10px',
      left: '10px',
      width: 'auto',
      maxWidth: 'calc(100vw - 20px)',
    },
    [theme.breakpoints.down('xs')]: {
      width: 'auto',
      height: 'auto',
      minHeight: '36px',
      padding: '6px 10px',
      gap: '6px',
      top: '8px',
      right: '8px',
      left: '8px',
      maxWidth: 'calc(100vw - 16px)',
    },
  },
  toastIcon: {
    width: '15px',
    height: '13.62px',
    flex: 'none',
    flexGrow: 0,
    [theme.breakpoints.down('xs')]: {
      width: '12px',
      height: '11px',
    },
  },
  toastText: {
    flex: 1,
    fontFamily: 'Roboto',
    fontStyle: 'normal',
    fontWeight: 700,
    fontSize: '12px',
    lineHeight: '150%',
    letterSpacing: '0.02em',
    color: '#127127',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    [theme.breakpoints.down('sm')]: {
      fontSize: '11px',
      lineHeight: '1.3',
    },
    [theme.breakpoints.down('xs')]: {
      fontSize: '10px',
      lineHeight: '1.2',
    },
  },
  // Chakra UI style tooltip classes
  chakraTooltip: {
    backgroundColor: '#2D3748 !important',
    color: '#ffffff !important',
    fontSize: '14px !important',
    fontWeight: '500 !important',
    borderRadius: '6px !important',
    boxShadow: '0 4px 12px rgba(0, 0, 0, 0.15) !important',
    border: 'none !important',
    maxWidth: '320px !important',
    padding: '12px 16px !important',
    lineHeight: '1.5 !important',
  },
  chakraTooltipArrow: {
    color: '#2D3748 !important',
  },
  tabs: {
    borderBottom: '1px solid #e0e0e0',
    width: 'auto',
    '& .MuiTab-root': {
      textTransform: 'none',
      fontWeight: 600,
      fontSize: '16px',
      minHeight: '48px',
      minWidth: 'auto',
      padding: '12px 24px',
      [theme.breakpoints.down('sm')]: {
        fontSize: '14px',
        padding: '10px 16px',
        minHeight: '44px',
      },
      [theme.breakpoints.down('xs')]: {
        fontSize: '12px',
        padding: '8px 12px',
        minHeight: '40px',
      },
    },
    '& .Mui-selected': {
      color: '#1a3552',
    },
    '& .MuiTabs-indicator': {
      backgroundColor: '#1a3552',
      height: '3px',
      [theme.breakpoints.down('xs')]: {
        height: '2px',
      },
    },
  },
  // Mobile card styles
  mobileCard: {
    marginBottom: '12px',
    boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
    borderRadius: '8px',
    '&:hover': {
      boxShadow: '0 4px 8px rgba(0,0,0,0.15)',
    },
  },
  mobileCardContent: {
    padding: '16px',
    '&:last-child': {
      paddingBottom: '16px',
    },
  },
  mobileCardHeader: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'flex-start',
    marginBottom: '16px',
  },
  mobileCardTitle: {
    fontSize: '16px',
    fontWeight: 600,
    color: '#333',
    flex: 1,
    marginRight: '8px',
  },
  mobileCardPrice: {
    fontSize: '18px',
    fontWeight: 700,
    color: '#1a3552',
  },
  mobileCardSection: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginBottom: '16px',
  },
  mobileCardLabel: {
    color: '#666',
    fontSize: '12px',
    marginBottom: '2px',
  },
  mobileCardValue: {
    fontWeight: 500,
    color: '#333',
  },
  mobileCardChip: {
    fontSize: '11px',
    height: '20px',
  },
  mobileOrderCard: {
    marginBottom: '16px',
    boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
    borderRadius: '8px',
  },
  mobileOrderHeader: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'flex-start',
    marginBottom: '16px',
  },
  mobileOrderTitle: {
    fontSize: '16px',
    fontWeight: 600,
    color: '#333',
    marginBottom: '4px',
  },
  mobileOrderDate: {
    color: '#666',
    fontSize: '12px',
  },
  mobileOrderTotal: {
    fontSize: '18px',
    fontWeight: 700,
    color: '#1a3552',
    marginBottom: '4px',
  },
  mobileBacklinkCard: {
    marginBottom: '8px',
    backgroundColor: '#f9f9f9',
    borderRadius: '6px',
  },
  mobileBacklinkContent: {
    padding: '12px',
  },
  mobileBacklinkHeader: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'flex-start',
    marginBottom: '8px',
  },
  mobileBacklinkDomain: {
    fontWeight: 600,
    color: '#333',
    fontSize: '13px',
  },
  mobileBacklinkDR: {
    color: '#666',
    fontSize: '11px',
  },
  mobileBacklinkLinks: {
    display: 'flex',
    gap: '8px',
    flexWrap: 'wrap',
  },
  mobileBacklinkLink: {
    color: '#1976d2',
    fontSize: '10px',
    textDecoration: 'none',
    '&:hover': {
      textDecoration: 'underline',
    },
  },
}));

export default useStyles; 